<template>
  <div>
    <div>
      <div>

        <div class="form__group">
          <label>{{ label }}</label>
          <!--                  <input-->
          <!--                      v-model="model"-->
          <!--                      :placeholder="placeholder"-->
          <!--                  />-->

          <select v-model="model" class="form__input">
            <option v-for="item in items" :value="item.value"
                    :selected="model == item.value ?'selected' : ''">{{ item.label }}
            </option>
          </select>
        </div>
      </div>

    </div>


  </div>
</template>

<script>

export default {
  name: 'ImageSelector',

  inheritAttrs: false,
  components: {},
  props: {
    label: String,
    items:Array,
    placeholder: String,
    modelValue: String,
  },
  data() {
    return {
      model: '',

    }
  },
  watch: {
    'model': function () {
      console.log("model changed", this.model)
      this.$emit('update:modelValue', this.model);
    },
    'modelValue': function () {
      this.model = this.modelValue
      this.$emit('update:modelValue', this.model);
    }
  },
  computed: {},
  mounted() {
if(this.modelValue!=null){
 this.model = this.modelValue
}
  },
  methods: {},


}
</script>
